// extracted by mini-css-extract-plugin
export default {"container":"statistic_container__kVGmk"};